import { GridItem, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SupplierCoverageHeatmapViewMode } from '../shared/types';

interface HeatmapCellProps {
  count: number;
  ids: number[];
  maxCount: number;
  viewMode: SupplierCoverageHeatmapViewMode;
  branchId: number;
  branchName: string;
  branchIdentifier: string;
  productGroupId: number;
  productGroupName: string;
  onClick: () => void;
}

const getColorIntensity = (count: number, maxCount: number): number => {
  if (count === 0) return 0;
  const percentage = count / maxCount;
  if (percentage <= 0.25) return 1;
  if (percentage <= 0.5) return 2;
  if (percentage <= 0.75) return 3;
  return 4;
};

const getCellColor = (intensity: number): string => {
  const colors = ['gray.200', '#FEB2B2', '#FC8181', '#F56565', '#C53030'];
  return colors[intensity];
};

export function HeatmapCell({
  count,
  ids: _ids,
  maxCount,
  viewMode,
  branchId: _branchId,
  branchName: _branchName,
  branchIdentifier,
  productGroupId: _productGroupId,
  productGroupName,
  onClick,
}: HeatmapCellProps) {
  const hasItems = count > 0;
  const { t } = useTranslation();
  const intensity = getColorIntensity(count, maxCount);
  const cellColor = getCellColor(intensity);

  const translationKey =
    viewMode === 'suppliers'
      ? 'supplierCoverageHeatmap.suppliers'
      : 'supplierCoverageHeatmap.articles';

  const handleClick = () => {
    if (hasItems) {
      onClick();
    }
  };

  return (
    <Tooltip
      label={`${branchIdentifier} - ${productGroupName}: ${t(
        translationKey as any,
        {
          count,
        },
      ).toString()}`}
    >
      <GridItem
        w="24px"
        h="24px"
        bg={cellColor}
        borderRadius="2px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        fontSize="10px"
        fontWeight="bold"
        color="white"
        cursor={hasItems ? 'pointer' : 'default'}
        _hover={hasItems ? { opacity: 0.8 } : {}}
        onClick={handleClick}
      >
        {hasItems ? count : ''}
      </GridItem>
    </Tooltip>
  );
}
